import {
  DOCUMENTS_ALL,
  DOCUMENTS_APPLICATION_DENTAL,
  DOCUMENTS_OA_HEALTH_QUEST,
  DOCUMENTS_TODO,
} from '@/config/constants'

import useLogger from '@/hooks/useLogger'
import useOvp from '@/hooks/useOvp'

const { logError } = useLogger()
const { getDocumentUrl } = useOvp()

function getTodoDocumentUrls(basket, documentTypes) {
  const todoTypes = documentTypes.filter(d => DOCUMENTS_TODO.includes(d)) ?? []
  
  const promises = todoTypes.map(type => getDocumentUrl(basket, type))
  
  return Promise.all(promises)
    .then(responses => {
      return responses.map((url, index) => {
        return {
          rel: todoTypes[index],
          href: url,
        }
      })
    })
    .catch(error => logError(['Failed loading todo document urls', error]))
}
  
function getInsuranceDocumentUrl(basket, documentTypes) {
  const insuranceDocuments = [DOCUMENTS_OA_HEALTH_QUEST, DOCUMENTS_ALL]
  // TODO: So there can anyway be only one insurance document? Otherwise use filter, check with Amit
  const insuranceType = documentTypes.find(d => insuranceDocuments.includes(d))
  if (!insuranceType) return undefined

  return getDocumentUrl(basket, insuranceType)
    .catch(error => logError(['Failed loading insurance document url', error]))
}
  
function getDentalDocumentUrl(basket, documentTypes) {
  if (!documentTypes.includes(DOCUMENTS_APPLICATION_DENTAL)) return undefined

  return getDocumentUrl(basket, DOCUMENTS_APPLICATION_DENTAL)
    .then(url => url)
    .catch(error => logError(['Failed loading dental document url'], error))
}

export default function useNextSteps() {

  async function getDocumentUrls(basket) {
    const documentTypes = basket.egate?.documents ?? []
    if (documentTypes.length === 0) return {}
  
    const documentUrls = { todo: [], insurance: [], dental: [] }
    documentUrls.todo = await getTodoDocumentUrls(basket, documentTypes)
    documentUrls.insurance = await getInsuranceDocumentUrl(basket, documentTypes)
    documentUrls.dental = await getDentalDocumentUrl(basket, documentTypes)
  
    return documentUrls
  }
    
  /**
   * Returns all existing translation keys for the given baseKey suffixed with an index until MAX_LIST_ITEMS
   * e.g. baseKey: a.b.c => ["a.b.c0","a.b.c1","a.b.c2"]
   * @returns []
   * @param {String}    baseKey
   * @param {Function}  $te
   */
  //TODO fetch as object, loop through values -> doesn't need te any more
  function getEnumeratedTranslations(baseKey, $te) {
    const MAX_LIST_ITEMS = 3
    const items = []
    for (let i = 0; i < MAX_LIST_ITEMS; i++) {
      const teKey = baseKey + i
      items.push(teKey)
    }
    return items.filter(item => $te(item))
  }

  return {
    getDocumentUrls,
    getEnumeratedTranslations
  }
}